import axios from "axios";
import React, { Component,useEffect } from "react";
import { connect } from "react-redux";
import {Link} from "react-router-dom";
import {
    set_datapage,
    getMapStateDefault,
  } from "@ora/recursos/src/redux/actions/DataPageAction";
import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import qs from 'query-string'
import { Chart } from "react-google-charts";
import $ from 'jquery'
import dt from 'datatables.net'
import "css/reportes/scrollbar.css";
import typeahead from 'corejs-typeahead'
import {PageLength} from "helpers/Datatables";
import { Helpers, Templates } from "@ora/recursos";
$.DataTable = dt
$.typeahead = typeahead

var ctm


class ImportacionesCites extends Component {
    filter = {
        buscar: '' 
    }
    datatable=null
    constructor (props) {
        super(props)

        this.state = {
            lista: false,
            cites: false,
            iucn: false,
            paises: false,
            recursos: false,
            tiporecurso:false,
            search:{txt_ncc:"",sel_year: "", sel_iucn: "",sel_recurso: "",sel_tiporecurso: "",sel_pais: ""} ,
            filter : {},
            regpag:process.env.REG_PAG,
            dataLoadingStatus: 'loading',
            chartData: [],
            total:0,
            datosCargados: false
          };
       
    }
    setDataPage = () => {
      
        this.props.set_datapage({ titulo: this.props.language('impor_citesimportacion'),
            isbackend:false,
            hasHeroBar: true,
            be_itemselect:"importaciones_cites",//clave de item del menu backend que se debe activar 
            breadcrumb:[
                {name:"Inicio",url:localUrl("/")},
                {name:"Reportes",url:"#"},
                {name: this.props.language('impor_citesimportacion'),url:"#",active:true},
            ]});
     }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log('ENLACES',prevProps.countDataPage, this.props.countDataPage)
        if (100 === +this.props.countDataPage) {
            this.setDataPage()
        
        }

    }
    getTokenPublic = ()=> {
        return  Helpers.ValidationAuth.getPublicAuthorization().replace('Basic', '').replace(' ', '').trim()
      }
    initTypeahead =  () => {
    
        const fnTargetText = (e, data) => {
            
            this.setState({          
                search: {
                    ...this.state.search,
                    txt_ncc: data.text
                }
            })

            
        }
        $('#txt_ncc').typeahead({
            highlight: true,
            hint: false,
            minLength: 1
            }, {
            async: true,
            name: 'search-importaciones',
            display: function display(d) {
                return d.text;
            },
            templates: {
                suggestion: h => {
                    if (h.asPlaceholder !== undefined) {
                        return `<div>Buscar <b>"${h.text}"</b></div>`
                    } else 
                        return `<div>${h.text}</div>`
                }
            },
            source: function source(q, cb, asy) {
                // let result = []
                if (q.trim() != '') {
                // var no_buscar = _this.cilindros.map(function (v) {
                //     return v.id;
                // });
                // console.log(no_buscar);
                // axios.get(BASE_URL + '/api/cilindro?m=all&q=' + q, {params: {cilindros: no_buscar}}).then(res => {
                cb([{count: 0, asPlaceholder: true, text: q.trim()}]);
                axios.get(baseUrl('cites/exportaciones/typeahead'), {
                    params: { q: q.trim() } 
                }).then(function (res) {
                    // console.log(res.data)
                    // return res.data
                    // res.data.unshift({count: 0, text: `Solo buscar "${q.trim()}"` })
                    asy(res.data);
                    // return res.data
                });

                // let regex = new RegExp(q, 'i');
                // cb(_this.listaBancos.filter(v => {
                //   return regex.test(v.banco_name)
                // }))
                }
            }
            }).bind('typeahead:select', fnTargetText).bind('typeahead:autocomplete', fnTargetText);
    }

    componentDidMount() {
        var params=qs.parse(this.props.location.search)
         this.setDataPage()
        var url=baseUrl(`cites/reportes/initimportacionescites?l=25&o=0`)
        var search=this.state.search
        if((params["q1"])){
            search['txt_ncc']=params["q1"]
            url+="&q1="+params["q1"]

        }
        if((params["q2"])){
            search['sel_year']=params["q2"]
            url+="&q2 n="+params["q2"]

        }
        if((params["q3"])){
            search['sel_iucn']=params["q3"]
            url+="&q3="+params["q3"]

        }
        if((params["q4"])){
            search['sel_tiporecurso']=params["q4"]
            url+="&q4="+params["q4"]

        }
        this.setState({
            search: search            
        })
        this.setFilter()
        axios.get(url).then(res => {
            this.initpage(res.data);
        })
    }

    setFilter(){
        this.setState({
            filter : {
                q1: this.state.search['txt_ncc'],
                q2: this.state.search['sel_year'],
                q3: this.state.search['sel_iucn'],
                q4: this.state.search['sel_tiporecurso']
            }
        })


        
    }

    initpage(result){




        var resultados = result;        
        console.info("%c--- get reporte ", "color:yellow;background:green");
        var search=this.state.search
        const itemYear= resultados.year.map((item) => {
            var selected=false
            if(this.state.search['sel_year']==item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
            return (
                <option value={item.exp_int_year} selected={selected}>{item.exp_int_year}</option>
            );
        })
        const itemPaises= resultados.paises.map((item) => {
            var selected=false
            if(this.state.search['sel_iucn']==item.code){search["sel_iucn"]=item.code;selected=true}
            return (
                <option value={item.code} selected={selected}>{item.name}</option>
            );
        })
      
        this.setState({
            year: itemYear,
            paises: itemPaises,
            search:search        
        })
        this.getSearch()
       
        
    }

    initDatatable = () => {
        

        const OnClick_acciones = (evt) => {
             let {accion, id} = evt.currentTarget.dataset
            switch (accion) {
                case 'ver':
                this.props.history.push(localUrl("/reportes/comercios/" + id))
                break;
            }
        }
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns p-4'<'column'l><'column'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/reportes/importacion_datatable?l=25&o=0&tq=1"),
              data: (d) => {
                
                d.filter = {
                    q1: this.state.search['txt_ncc'],
                    q2: this.state.search['sel_year'],
                    q3: this.state.search['sel_iucn'],
                    q4: this.state.search['sel_tiporecurso'],
                }
                return d
              },
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            },
            columns: [
              { data: "exp_int_id" , render: (d, t, r)=>{
                return r.index
              }},
              { data: "exp_int_year" },
              { data: "exp_txt_taxon" },
              { data: "exp_txt_appendix" },
              { data: "exp_txt_term" },
              { data: "exp_int_quantity" },
              { data: "exp_txt_unit" },
              { data: "pais_importer" },
              { data: "pais_exporter" },
              { data: "exp_int_id", render: (d, t, r) => {
                  return `
                  <div class="buttons is-centered">
                  <button data-id="${d}" data-accion="ver" class="button is-small is-primary btn-acciones buttonb" title="Ver">
                      <span class="icon is-small"><i class="fas fa-eye"></i></span>
                  </button>
              </div>
                    `
              } }
            ],
            drawCallback: () => {
                
                $('#tblImportacion_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblImportacion_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblImportacion_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblImportacion_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblImportacion_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblImportacion')
        
        // setTimeout(() => {
            
            this.datatable = this.table.DataTable(this.configDT).on('click', '.btn-acciones', OnClick_acciones)

        // }, 20000)
    }

    cargarregistros(datos){
        const listaItems = datos.registros.map((item,index) => {
            return (             
               <tr key={"registro_" + item.exp_int_id}>
               <td className="is-checkbox-cell">
                   {index+1}                               
               </td> 
               <td >{item.exp_int_year}</td>                              
               <td >{item.exp_txt_taxon}</td>
               <td>{item.exp_txt_term}</td>
               <td >{item.exp_int_quantity}</td>
               <td >{item.exp_txt_unit}</td>
               <td>{item.pais_importer}</td>
               <td>{item.pais_exporter}</td>
               <td className="is-actions-cell">
               <div className="buttons is-right">
               <Link className="button is-small is-primary"  to={localUrl("/reportes/comercios/"+item.exp_int_id)}>
               <span className="icon"><i className="mdi mdi-eye"></i></span>
               </Link>
               </div>
               </td>
               </tr>
            );
          });
          this.setState({
            lista: listaItems,
            total:datos.total
        })
    }

    cargarchartyear(datos){
        // let year = [
        //     ['Años', 'Cantidad']       
        // ]
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.yearchart)

        datos.yearimp.map(year =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Año')
                datos.paisimp.map(pais=>{
                    filaDatachart.push(pais.pais)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(year.exp_int_year) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.paisimp.map(pais=>{
                
                row = arrayData.find(data => data[1].pais == pais.pais && data[1].exp_int_year == year.exp_int_year) //CONDICION
                
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })

            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })

          this.setState({
            yearChart: DataChart,
            dataLoadingStatus: 'ready'
        })
        
        this.initTypeahead()
        this.initDatatable()
    }
    cargarchartpresentacionyear(datos){
         
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.termimp)

        datos.yearimp.map(year =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Año')
                datos.allterm.map(term=>{
                    filaDatachart.push(term.termino)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(year.exp_int_year) //PRIMER ELEMENTO DEL ROW
            //console.log(datos.allterm)
            datos.allterm.map(term=>{
                row = arrayData.find(data => data[1].termino == term.termino && data[1].exp_int_year == year.exp_int_year) //CONDICION
                //console.log(data)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            termChart: DataChart,
        })

    }
    cargarchartespeciepais(datos){
        
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.espepais)

        datos.alltaxon.map(taxon =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Especie')
                datos.paisimp.map(pais=>{
                    filaDatachart.push(pais.pais)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(taxon.exp_txt_taxon) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.paisimp.map(pais=>{
                
                row = arrayData.find(data => data[1].pais == pais.pais && data[1].especie == taxon.exp_txt_taxon) //CONDICION
                //console.log(arrayData)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            taxonChart: DataChart,
        })
    }
    cargarchartimporter(datos){
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.presenpais)

        datos.allpresen.map(term =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Presentacion')
                datos.paisimp.map(pais=>{
                    filaDatachart.push(pais.pais)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(term.exp_txt_term) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.paisimp.map(pais=>{
                
                row = arrayData.find(data => data[1].pais == pais.pais && data[1].termino == term.exp_txt_term) //CONDICION
                //console.log(arrayData)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            presenChart: DataChart,
        })
    }
    cargarchartespecie(datos){
        let especie = [
            ['Especie', 'Cantidad']       
        ]
        datos.especiechart.map((item,index) => {
        //console.log(datos.yearchart)
        especie.push([item.exp_txt_taxon,parseInt(item.cantidad)])
          });
          this.setState({
            especieChart: especie
        })
    }

    buscar_simple = () => {
        this.datatable.destroy();
        $('#btnBuscar').addClass('is-loading')
        this.getSearch();
        var url=this.getParamsUrl("/reportes/importaciones?");  
        this.props.history.push(localUrl(url))  
        this.setFilter()     
    }
    getSearch(){
        let url=this.getParamsUrl("cites/reportes/importacionescites"); 
        url=baseUrl(url)
        
        this.setState({datosCargados : true})

        let url_reportes
        let func
        let loading =<div  className="field">
                        <h2 className="tamano is-2"> Cargando... </h2>
                    </div>
        let is_one_chart = false
        let chart_1_loading = ""
        let chart_2_loading = ""



        if(this.state.filter.q1){
            this.setState({
                busquedaespecie:true
            })
        }
       
        if(this.state.search.txt_ncc && this.state.search.sel_year && this.state.search.sel_iucn){
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=q1q2q3&"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_q1q2q3"

            is_one_chart = true
        }
        else if(this.state.search.txt_ncc && this.state.search.sel_year){
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=q1q2&"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_q1q2"

            is_one_chart = false
        }
        else if(this.state.search.txt_ncc && this.state.search.sel_iucn){
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=q1q3&"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_q1q3"

            is_one_chart = false
        }
        else if(this.state.search.sel_year && this.state.search.sel_iucn){
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=q2q3&"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_q2q3"

            is_one_chart = false
        }
        else if(this.state.search.txt_ncc){
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=q1&"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_q1"

            is_one_chart = false
        }
        else if(this.state.search.sel_year){
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=q2&"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_q2"

            is_one_chart = false
        }
        else if(this.state.search.sel_iucn){
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=q3&"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_q3"

            is_one_chart = false
        }
        else{
            url_reportes=this.getParamsUrl("cites/reportes/importacionescites?f=no_q"); 
            url_reportes=baseUrl(url_reportes)
            func = "func_no_q"

            is_one_chart = false
        }

        if(is_one_chart){
            chart_1_loading = loading
            chart_2_loading = ""
        }
        else{
            chart_1_loading = loading
            chart_2_loading = loading
        }

        //alert(url_reportes)

        this.setState({
            chart_1: chart_1_loading,
            chart_2: chart_2_loading
        })

        axios.get(url_reportes).then(res =>{

            //alert(func)

         
            this[func](res.data.datos)

            this.initTypeahead()
            this.initDatatable()
            $('#btnBuscar').removeClass('is-loading')

            this.setState({
                dataLoadingStatus: 'ready',
                total : res.data.datos.total
            })
        })
    }

      //Cargar chart barras multiples
      cargarchartbarrasmultiples(datos, data_x_column, axis_y_column, x, name_x, y, y_first_name, name_y, charName, confObjChar, label_x = ''){
        // let year = [
        //     ['Años', 'Cantidad']       
        // ]


        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true
        let total_data = 0

        let arrayData = Object.entries(datos)

        console.log(arrayData)

        console.log(x)
        console.log(y)

        y.map(y_el =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push(y_first_name)
                x.map(x_el=>{
                    filaDatachart.push(x_el[label_x || name_x])
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            

            //CONTENIDO
            filaDatachart.push(y_el[name_y]) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            x.map(x_el=>{
                let i = x_el[name_x]
                let j = y_el[name_y]

                //console.log(j)
                //console.log(i)

                row = arrayData.find(data => data[1][data_x_column] == i && data[1][axis_y_column] == j) //CONDICION
                
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION´
                    {   
                        total_data = total_data + 1
                        filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                    } 
                else
                    filaDatachart.push(0)
            })

            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })

       
        this.setState({
            [charName]: this.renderChart(DataChart, total_data, confObjChar),
            dataLoadingStatus: 'ready'
        })
       
    }
    //Chart barras simple
    cargarChartBarrasSimple(datos, x_first, x_col, y_first, y_col, chartName, confObjChar){
        let totalData = 0
        let dataChart = [
            [x_first, y_first]       
        ]

        datos.map((item,index) => {
        //console.log(datos.yearchart)
        totalData = totalData + 1
        dataChart.push([item[x_col],parseInt(item[y_col])])
          });
          this.setState({
            [chartName]: this.renderChart(dataChart, totalData, confObjChar)
        })
    }

    //Fin chart barras simple

    //RenderizarChart
    renderChart(data, total_data, objConf)
    {


        if(total_data > 0){

            let CharTitle = objConf.CharTitle
            let hAxisTitle = objConf.hAxisTitle
            let vAxisTitle = objConf.vAxisTitle
            let id = objConf.id
            
            return (
            
            <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart</div>}
            
            data={data}
            options={
                {
                    legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                    title: CharTitle,
                    chartArea: { width: '65%' },
                    isStacked: true,
                    hAxis: {
                    title: hAxisTitle,
                    minValue: 0,
                    },
                    vAxis: {
                    title: vAxisTitle,
                    }}
            }
            // For tests
            rootProps={{ 'data-testid': id }}
            />)
        }
        else{
            return (
                <div className="is-3"> <h3 className="is-3"> No se encontraron importaciones para este gráfico</h3></div>
            )
        }

       

    }


    //traer reportes

    //sin parámetros
    func_no_q(data){
        let objConf1 ={
            CharTitle : this.props.language('impor_graficonoq1'),
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Año',
            id: '1'
        }
        this.cargarchartbarrasmultiples(data.chart_1, 'pais', 'exp_int_year', data.x_1, 'pais', data.y, 'Año', 'exp_int_year', 'chart_1', objConf1)
        
        let objConf2 ={
            CharTitle : this.props.language('impor_graficonoq2'),
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Año',
            id: '2'
        }
        this.cargarchartbarrasmultiples(data.chart_2, 'termino', 'exp_int_year', data.x_2, 'termino', data.y, 'Especie', 'exp_int_year', 'chart_2', objConf2, 'var_txt_name')
    }

    func_q1(data){
        let objConf1 ={
            CharTitle : this.props.language('impor_graficoq11')+' '+this.state.search['txt_ncc'],
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Año',
            id: '1'
        }
        this.cargarchartbarrasmultiples(data.chart_1, 'pais', 'exp_int_year', data.x_1, 'pais', data.y, 'Año', 'exp_int_year', 'chart_1', objConf1)
        
        let objConf2 ={
            CharTitle : this.props.language('impor_graficoq12')+' '+this.state.search['txt_ncc'],
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Año',
            id: '2'
        }
        this.cargarchartbarrasmultiples(data.chart_2, 'termino', 'exp_int_year', data.x_2, 'termino', data.y, 'Especie', 'exp_int_year', 'chart_2', objConf2, 'var_txt_name')

       }

    func_q2(data){

        let objConf1 ={
            CharTitle : this.props.language('impor_graficoq21')+' '+this.state.search.sel_year,
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Especie',
            id: '1'
        }
        this.cargarchartbarrasmultiples(data.chart_1,'pais','especie', data.x, 'pais', data.y_1, 'Año', 'exp_txt_taxon', 'chart_1', objConf1)
        
        let objConf2 ={
            CharTitle : this.props.language('impor_graficoq22')+' '+this.state.search.sel_year,
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Presentación',
            id: '2'
        }
        this.cargarchartbarrasmultiples(data.chart_2,'pais','termino', data.x, 'pais', data.y_2, 'Especie', 'exp_txt_term', 'chart_2', objConf2)
    }

    func_q3(data){

        let objConf1 ={
            CharTitle : this.props.language('impor_graficoq31')+' '+data.isocode_pais ,
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Especie',
            id: '1'
        }
        this.cargarchartbarrasmultiples(data.chart_1,'exp_int_year','especie', data.x_1, 'exp_int_year', data.y_1, 'Especie', 'exp_txt_taxon', 'chart_1', objConf1)
        
        let objConf2 ={
            CharTitle : this.props.language('impor_graficoq32')+' '+data.isocode_pais ,
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Presentación',
            id: '2'
        }
        this.cargarchartbarrasmultiples(data.chart_2,'termino','exp_int_year', data.x_2, 'termino', data.y_2, 'Año', 'exp_int_year', 'chart_2', objConf2, 'var_txt_name')
    }

    func_q1q2(data){

        let objConf1 ={
            CharTitle : this.props.language('impor_graficoq1q21')+' '+this.state.search['txt_ncc']+' '+this.props.language('impor_graficoq1q21year')+' '+this.state.search.sel_year ,
            hAxisTitle: 'Cantidad',
           vAxisTitle: 'País',
         id: '1'
        }
        this.cargarChartBarrasSimple(data.chart_1, 'Pais', 'pais', 'Cantidad','cantidad', 'chart_1', objConf1)
        
        let objConf2 ={
            CharTitle : this.props.language('impor_graficoq1q22')+' '+this.state.search['txt_ncc']+' '+this.props.language('impor_graficoq1q22porlospaisesmiembros')+' '+this.state.search.sel_year ,
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Presentación',
            id: '2'
        }
        this.cargarchartbarrasmultiples(data.chart_2,'pais','termino', data.x_2, 'pais', data.y_2, 'Año', 'exp_txt_term', 'chart_2', objConf2)
    }
    func_q1q3(data){

        let objConf1 ={
            CharTitle : this.props.language('impor_graficoq1q31')+' '+data.isocode_pais+' de la especie '+this.state.search.txt_ncc ,
            hAxisTitle: 'Cantidad',
           vAxisTitle: 'Año',
         id: '1'
        }
        this.cargarChartBarrasSimple(data.chart_1, 'Año', 'exp_int_year', 'Cantidad','cantidad', 'chart_1', objConf1)
        
        let objConf2 ={
            CharTitle : this.props.language('impor_graficoq1q32')+' '+this.state.search.txt_ncc+' en '+data.isocode_pais+' '+this.props.language('impor_graficoq1q32año') ,
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Año',
            id: '2'
        }
        this.cargarchartbarrasmultiples(data.chart_2,'exp_txt_term','exp_int_year', data.x_2, 'termino', data.y_2, 'Año', 'exp_int_year', 'chart_2', objConf2)
    }

    func_q2q3(data){

        let objConf1 ={
            CharTitle : this.props.language('impor_graficoq2q31')+' '+data.isocode_pais+' '+this.props.language('impor_graficoq1q21year')+' '+this.state.search.sel_year ,
            hAxisTitle: 'Cantidad',
           vAxisTitle: 'Especie',
         id: '1'
        }
        this.cargarChartBarrasSimple(data.chart_1, 'Taxon', 'exp_txt_taxon', 'Cantidad','cantidad', 'chart_1', objConf1)
        
        let objConf2 ={
            CharTitle : this.props.language('impor_graficoq2q32')+' '+data.isocode_pais+' '+this.props.language('impor_graficoq1q21year')+' '+this.state.search.sel_year ,
            hAxisTitle: 'Cantidad',
            vAxisTitle: 'Presentación',
            id: '2'
        }
        this.cargarChartBarrasSimple(data.chart_2, 'Término', 'exp_txt_term', 'Cantidad','cantidad', 'chart_2', objConf2)
    }

    func_q1q2q3(data){
        let objConf ={
            CharTitle : this.props.language('impor_graficoq1q2q3')+' '+data.isocode_pais+' '+this.props.language('impor_graficoq1q21year')+' '+this.state.search.sel_year+' '+this.props.language('impor_graficoq1q31especie')+' '+this.state.search['txt_ncc'],
            hAxisTitle: 'Cantidad',
           vAxisTitle: 'Presentación',
         id: '1'
        }
        this.cargarChartBarrasSimple(data.chart_1, 'Presentación', 'exp_txt_term', 'Cantidad','cantidad', 'chart_1', objConf)
    }



    getParamsUrl(url){
        let isFirst = false
        if(this.state.search['txt_ncc']!=""){
            if(!isFirst)
                url+="q1="+this.state.search['txt_ncc']
            else
                url+="&q1="+this.state.search['txt_ncc']
            isFirst = true
        }
        if(this.state.search['sel_year']!=""){
            if(!isFirst)
                url+="q2="+this.state.search['sel_year']
            else
                url+="&q2="+this.state.search['sel_year']
            isFirst = true
        }
        if(this.state.search['sel_iucn']!=""){
            if(!isFirst)
                url+="q3="+this.state.search['sel_iucn']
            else
                url+="&q3="+this.state.search['sel_iucn']
            isFirst = true
        }
        if(this.state.search['sel_tiporecurso']!=""){ 
            if(!isFirst)
                url+="q4="+this.state.search['sel_tiporecurso']
            else
                url+="&q4="+this.state.search['sel_tiporecurso']  
            isFirst = true  
        }
        return url;

    }

    ir_detalle = (e) => {
        const { especie } = e.target.dataset;
        var url="/reportes/fichaespecie/"+especie
        this.props.history.push(localUrl(url)) 
        
    }
    onClick_descargar = (e) => {
        e.preventDefault()
        let tokenDownload = Helpers.ValidationAuth.getPublicAuthorization().replace('Basic', '').replace(' ', '').trim()
        let params = this.datatable.ajax.params()
        window.open(baseUrl("cites/reportes/importacion_datatable?l=25&o=0&tq=1") + '&' + $.param(params) + '&format=download' + (tokenDownload ? `&token=${tokenDownload}` : ''), '_blank').focus();
      }
    gestionarCambio = (event) => {
        var search=this.state.search
        if (event.target.type === "radio") {
            search[event.target.name]=event.target.value;
        } else {
            search[event.target.id]=event.target.value;
        }
        this.setState({          
            search:search
        })
      };

    render() {
        return this.state.dataLoadingStatus === 'ready' ?(
            <Templates.Default.BasePageRoute2 localUrl={localUrl} dataPage={this.props.DataPage}>
            <div>
                <section className="sectionx is-main-section">
                <div class="card">
                    <header class="card-header">
                        <div class="card-header-title">
                        Filtro
                        </div>
                       
                    </header>
                    <div class="card-content">
                        <div className="field is-horizontal">
                            <div className="field-body">
                                   <div className="field">
                                       <label className="label">{this.props.language('impor_nombrecientifico')}</label>
                                       <div className="control">
                                           <input className="input is-expanded" id="txt_ncc" size="50" type="text" autoComplete="off" placeholder="Ingrese nombre cientifico o común"  onChange={this.gestionarCambio} value={this.state.search.txt_ncc}></input>
                                       </div>
                                   </div>
                                   <div className="field">
                                       <label className="label">{this.props.language('impor_year')}</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_year"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.year}                                                          
                                           </select>
                                           </div>
                                       </div>
                                   </div>
                                   {/* <div className="field ">
                                       <label className="label">Pais Exportador</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_iucn"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.paises}                                                           
                                           </select>
                                           </div>
                                       </div>
                                   </div> */}
                                   <div className="field ">
                                       <label className="label">{this.props.language('impor_pais')}</label>
                                       <div className="field is-grouped">
                                        <div className="control">
                                            <div className="select">
                                            <select id="sel_iucn"  onChange={this.gestionarCambio}>
                                                <option value="">--Seleccione--</option>
                                                {this.state.paises}                                                           
                                            </select>
                                            </div>
                                        </div>
                                        <p className="control">
                                            <button className="button is-link" id="btnBuscar" onClick={this.buscar_simple}>{this.props.language('impor_buscar')}</button>
                                        </p>
                                       </div> 
                                   </div> 
                            </div>           
                        </div>
                    </div>
                    
                </div>
                <div class="card">
                    <header class="card-header">
                        <div class="card-header-title">
                        {this.props.language('impor_resumen')}
                        </div>
                       
                    </header>
                    <div class="card-content">
                        <div className="columns" id="especie1">
                            <div className="column is-12">
                                {this.state.chart_1}
                            </div> 
                        </div>
                        <div className="columns" id="especie2">
                                <div className="column is-12">
                                {this.state.chart_2}
                                </div>                  
                        </div>
                    </div>
                
                </div>
                      <div className="card has-table">                  
                        <div className="notification is-card-toolbar">
                            <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <strong>{this.props.language('impor_listresultados')}</strong> 
                                </div>
                               
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                Se encontraron <strong className="mx-1">{this.state.total}</strong> registros                            
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="card-content">
                        <div className="column">
                <div className="control"><div className="buttons is-justify-content-right"><button onClick={ this.onClick_descargar } id="btnGenerar" className="button is-primary"><i className="fas fa-download"></i>&nbsp;{ this.props.language('descargar', 'Descargar') }</button></div></div>
                </div>

                            <div className="b-table has-pagination">
                                <div className="table-wrapper has-mobile-cards">
                                    <table  id="tblImportacion" className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                                        <thead>
                                        <tr>
                                            <th> # </th>
                                            <th>Año</th>
                                            <th>Taxon</th>
                                            <th>Apéndice</th>
                                            <th>Term</th>
                                            <th>Volumen</th>
                                            <th>Unidad</th>
                                            <th>Importador</th> 
                                            <th>Exportador</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                                                         
                                        </tbody>
                                        
                                    </table>
                                </div>
                                 {/* <div className="notification">
                                    <div className="level">
                                    <div className="level-left">
                                        <div className="level-item">
                                        <div className="buttons has-addons">
                                            <button type="button" className="button is-active">1</button>
                                            <button type="button" className="button">2</button>
                                            <button type="button" className="button">3</button>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="level-right">
                                        <div className="level-item">
                                        <small>Page 1 of 3</small>
                                        </div>
                                    </div>
                                    </div>
                                </div>  */}
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            </Templates.Default.BasePageRoute2>
        ):(
            
                
            <div className="columns is-justify-content-center mb-6">
                <div className="column is-12">
                <div className="field is-horizontal">
                    <div className="field-body">
                        <div  className="field pt-2">
                            <div ref={ this.spinnerLoad } className="ld ld-spinner  ld-spin">
                            </div>
                        </div>
                        <div  className="field">
                             <h2 className="tamano is-2"> Cargando... </h2>
                        </div>
                    </div>
                    
                </div>
            </div>
            
            
            
            </div>
  
        )
    }
}


// export default connect(getLanguage, {set_datapage, SetLanguage})(ImportacionesCites)
export default connect(getMapStateDefault(), {
    set_datapage,
    // seDatatDocumentos,
    // setEstandarData,
    // checkEstandarData,
    // checkDataDirectorio,
  })(ImportacionesCites);